import {createViewConfig} from '@sail/engine';
import type {PopoverProps} from './PopoverProps';

export const PopoverConfig = createViewConfig({
  props: {} as PopoverProps,
  name: 'Popover',
  defaults: {
    placement: 'bottom',
    dismissible: true,
    showOnPress: false,
    showOnFocus: false,
    showOnHover: false,
  },
});
